import { AppHeader, AppHeaderBackButton, Box, Container, Typography } from '@ace-clublabs/shared-component-library';
import { RoleTypeForm } from '../components/RoleTypeSelection/RoleTypeForm';
import { useGlobalState } from '../state/state';
import { stringHelper } from '../utils/stringHelper';
import { CurrentPayPlan, RoleType } from '@ace-clublabs/common-membership-api-types';
import { useEffect, useLayoutEffect, useState } from 'react';
import { UtagHelper, UtagType } from '../utils/UtagHelper';
import { isAddFamilyMembersAllowed } from '../state/helpers';
import { MaxAssociateWarningModal } from '../components/MaxAssociateWarningModal/MaxAssociateWarningModal';
import { GreenBoxMessage } from '../components/GreenBox/GreenBoxMessage';

export const RoleTypeSelection: React.FC = () => {
  const [memberDetails] = useGlobalState('memberDetails');
  const [isMobileApp] = useGlobalState('isMobileApp');
  const [tags] = useGlobalState('tags');
  const [formData] = useGlobalState('formData');
  const [prospectiveCosts] = useGlobalState('prospectiveCosts');
  const [isTagging, setTagging] = useState(true);
  const [content] = useGlobalState('content');

  useLayoutEffect(() => {
    UtagHelper.sendTag(UtagType.view, tags, 'select member type');
    setTagging(false);
  }, []);

  const benefitLevel = formData?.requestedMembershipLevel;
  const familyCosts = prospectiveCosts[benefitLevel?.toLowerCase() as keyof typeof prospectiveCosts]?.familyCosts;
  const familyCost = familyCosts?.cost ?? 0;
  const familyUpgradeFee = familyCost - (familyCosts?.discount ?? 0);

  const roles = memberDetails?.prospectiveMemberRules?.memberRoles;
  const AS_role = roles?.find((role) => role.roleType === RoleType.ASSOCIATE);
  const canAddAssociateRoleType = AS_role?.maximumAllowed! > 0;
  const [membershipDetails] = useGlobalState('memberDetails');
  const addFamilyMembersAllowed = isAddFamilyMembersAllowed(membershipDetails);
  const [showMaxAssociateWarningModal, setShowMaxAssociateWarningModal] = useState(false);

  useEffect(() => {
    setShowMaxAssociateWarningModal(!addFamilyMembersAllowed);
  }, []);

  if (isTagging) {
    return <></>;
  }

  return (
    <>
      <Container maxWidth="sm">
        <Box
          sx={{
            marginTop: '1.5rem',
          }}
        >
          <AppHeader backButton={!isMobileApp && <AppHeaderBackButton />} />
          <Typography variant="h5" sx={{ marginBottom: '16px' }} id="select-role-type-title">
            Let’s add a family member
          </Typography>
          {familyCost > 0 && (
            <Typography id="family-upgrade-fee-label" sx={{ marginTop: '-8px', marginBottom: '16px' }}>
              {memberDetails?.currentBillPlan === CurrentPayPlan.RECURRINGMONTHLY ? (
                <>
                  There is a monthly upgrade fee of{' '}
                  <strong>{stringHelper.formatMoney(familyUpgradeFee.toString())}</strong> to add family members.
                </>
              ) : (
                <>
                  There is a <strong>{stringHelper.formatMoney(familyUpgradeFee.toString())}</strong> fee for a Family
                  Upgrade.
                </>
              )}
            </Typography>
          )}
          {content.greenBoxMessage && (
            <GreenBoxMessage
              shortBoxMessage={content.greenBoxMessage.shortBoxMessage}
              modalTitle={content.greenBoxMessage.modalTitle}
              modalBody={content.greenBoxMessage.modalBody}
            />
          )}
          {canAddAssociateRoleType ? (
            content.greenBoxMessage ? (
              <Typography variant="b1Regular" sx={{ marginTop: '1.5rem' }}></Typography>
            ) : (
              <></>
            )
          ) : (
            <Typography variant="b1Regular" id="select-one-label" sx={{ marginTop: '1rem' }}>
              Select one
            </Typography>
          )}
          <RoleTypeForm />
        </Box>
      </Container>
      <MaxAssociateWarningModal
        visible={showMaxAssociateWarningModal}
        onClose={() => {
          setShowMaxAssociateWarningModal(false);
        }}
      />
    </>
  );
};
